import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import formatPrice from '@honda-canada/js-utilities/lib/formatPrice';
import React, { useMemo } from 'react';
import { Box } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import PaymentCalculatorSectionTitle from '../shared/PaymentCalculatorSectionTitle';
import themeStyles from './AdditionalSavings.styles';
import useOffersDictionaryConverter from './UseOffersDictionaryConverter';
import { LabeledCheckbox } from '../shared/LabeledItem';
import { useLanguage } from '../../../utils/sitecoreContext';
const Wrapper = themeStyles.apply(Box, 'Wrapper');
const CheckboxesContainer = themeStyles.apply(Box, 'CheckboxesContainer');
const AdditionalSavings = ({ disableAllFields, incentiveOffers, onOfferSelected, selectedOfferIds, }) => {
    const language = useLanguage();
    const { t } = useTranslation();
    const { getDictionaryValues } = useOffersDictionaryConverter();
    const offersWithDictionaryValues = useMemo(() => incentiveOffers === null || incentiveOffers === void 0 ? void 0 : incentiveOffers.map(offer => {
        const { tooltip, label } = getDictionaryValues(offer.name);
        return {
            ...offer,
            tooltip,
            label: label || offer.name,
        };
    }), [incentiveOffers, getDictionaryValues]);
    return (_jsxs(Wrapper, { style: { paddingBottom: '16px' }, children: [_jsx(PaymentCalculatorSectionTitle, { "data-testid": "cy-bap-additional-savings-title", children: t('Pages.Bap.additionalSavingsLabel') }), _jsx(CheckboxesContainer, { children: offersWithDictionaryValues === null || offersWithDictionaryValues === void 0 ? void 0 : offersWithDictionaryValues.map((offer) => {
                    const isSelected = (selectedOfferIds === null || selectedOfferIds === void 0 ? void 0 : selectedOfferIds.includes(offer.id)) || false;
                    return (_jsx(LabeledCheckbox, { checked: isSelected, onClick: () => {
                            if (onOfferSelected) {
                                onOfferSelected(offer.id, !isSelected);
                            }
                        }, label: offer.label || offer.name, tooltipText: offer.tooltip, name: offer.name, disabled: disableAllFields, rightSideText: `-${formatPrice(offer.value, language, 2)}` }, offer.id));
                }) })] }));
};
export default AdditionalSavings;
